import {
    createRouter,
    createWebHistory
} from "vue-router";
import methods from '@/methods/methods.js'
import System from './system'
import Statistics from './statistics'
import AccountCenter from './accountCenter'
import OperationsLog from './operationsLog'
import PrivateAssets from './privateAssets'
import MonitoringConfiguration from './monitoringConfiguration'
import {
    getCurrentMenu
} from '@/api/common/public'
import store from '../store/index'
const routes = [{
        path: "/",
        redirect: "/public"
    }, {

        path: "/login",
        name: "login",
        component: () => import("../views/public/login.vue"),

    },
    {
        path: "/public",
        name: "public",
        component: () => import("../views/public/index.vue"),
        children: [
            ...System,
            ...Statistics,
            ...AccountCenter,
            ...OperationsLog,
            ...PrivateAssets,
            ...MonitoringConfiguration,
        ]
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
// 确保在内页时刷新页面导致vuex中存储的权限列表没了无法判断
router.beforeEach((to, form, next) => {
    if (to.path == '/login' || !methods.getToken()) {
        return next()
    }
    store.commit('setQuery', to.query)
    let operation = store.state.operation
    if (!Object.keys(operation).length) {
        getCurrentMenu().then(res => {
            store.commit('setOperation', res.operation)
            next()
        })
    } else {
        next()
    }
})
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        location.reload();
    }
});

export default router;